import React from 'react'
import PropTypes from 'prop-types'
import { Box, Fab, styled } from '@mui/material'
import { ReactComponent as FillSvg } from 'images/fill-1.svg'
import { Spinner } from 'packages/eid-ui'

const activeColor = '#0057A0'
const whiteColor = '#ffffff'
const disabledColor = '#8b909a'

const StyledFab = styled(Fab, {
    shouldForwardProp: (prop) => prop !== 'active' && prop !== 'height',
})(({ active, height }) => ({
    width: 'auto',
    height: height,
    borderRadius: '30px',
    textTransform: 'capitalize !important',
    backgroundColor: active ? activeColor : 'transparent',
    border: `solid 1px ${activeColor}`,
    color: active ? whiteColor : activeColor,
    boxShadow: active ? '0 5px 5px -2px rgba(48, 127, 193, 0.55)' : 'none',
    '&:hover': {
        backgroundColor: active ? activeColor : `${activeColor} !important`,
        boxShadow: '0 5px 5px -2px rgba(48, 127, 193, 0.55) !important',
        color: 'white !important',
        '& path': {
            fill: whiteColor,
        },
    },
    '& path': {
        fill: active ? whiteColor : undefined,
    },
    '&.Mui-disabled': {
        backgroundColor: 'transparent !important',
        color: `${disabledColor} !important`,
        borderColor: disabledColor,
        '& path': {
            fill: disabledColor,
        },
    },
}))

const StyledLoader = styled(Box)({
    marginRight: '7px',
})

const CustomButton = ({
    onClick,
    label,
    width,
    height,
    active,
    loading,
    disabled,
}) => {
    return (
        <StyledFab
            size="medium"
            onClick={onClick}
            disabled={disabled}
            active={active}
            height={height}
        >
            <Box
                style={{ padding: '0 15px' }}
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                {loading ? (
                    <>
                        <StyledLoader>
                            <Spinner size={0.8} />
                        </StyledLoader>
                        {label}
                    </>
                ) : (
                    label
                )}
                {!loading && (
                    <Box
                        padding="0px 5px 0 5px"
                        display="flex"
                        alignItems="center"
                    >
                        <FillSvg></FillSvg>
                    </Box>
                )}
            </Box>
        </StyledFab>
    )
}
CustomButton.propTypes = {
    label: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    onClick: PropTypes.func,
}

CustomButton.defaultProps = {
    label: 'Custom Button',
    height: 33,
}

export default CustomButton
